import React from 'react';
import {
    HomeContainer,
    Presentation,
    ResourceItems,
    StatusUpdate,
    Title,
    Blob,
} from './Home.styled';
import GitHubIcon from '../assets/AiFillGithub';
import LinkedInIcon from '../assets/LinkedinLogo';

const Home = () => {
    return (
        <HomeContainer>
            <Title>
                Hi, I'm{' '}
                <span
                    style={{
                        fontWeight: 'bold',
                        color: 'var(--primary-color)',
                    }}
                >
                    Eliyahou Gabbay
                </span>
            </Title>
            <Presentation>
                AI engineer specialized in production systems.
                <br />
                <br />
                Check my work below and book a free 20-min call.
            </Presentation>

            <ResourceItems>
                <StatusUpdate>
                    <Blob />
                    <p>Available</p>
                </StatusUpdate>
                <a
                    href="https://linkedin.com/in/eg-955a62198/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <LinkedInIcon />
                </a>
                <a href="https://github.com/eliyahougabbay" target="_blank">
                    <GitHubIcon />
                </a>
            </ResourceItems>
        </HomeContainer>
    );
};

export default Home;
